import React from "react";
import { graphql, PreloadedQuery, usePreloadedQuery } from "react-relay";
import { WidgetTaskSingle } from "widgets";
import {
  WidgetTaskSingleMockPreviewQuery,
  WidgetTaskSingleSize,
} from "./__generated__/WidgetTaskSingleMockPreviewQuery.graphql";

export const WidgetTaskSingleMockPreviewQUERY = graphql`
  query WidgetTaskSingleMockPreviewQuery(
    $storecastId: ID!
    $input: PreviewWidgetTaskSingleInput!
  ) @raw_response_type {
    dashboard(id: $storecastId) @required(action: THROW) {
      previewWidgetTaskSingle(input: $input) {
        ...WidgetTaskSingle_widgetTaskSingle
      }
    }
  }
`;

export function WidgetTaskSingleMockPreview(props: {
  storecastId: string;
  clientForceSize: WidgetTaskSingleSize;
  queryRef: PreloadedQuery<WidgetTaskSingleMockPreviewQuery>;
}) {
  const data = usePreloadedQuery(
    WidgetTaskSingleMockPreviewQUERY,
    props.queryRef
  );
  return (
    <WidgetTaskSingle
      mode="IDLE"
      widget={data.dashboard.previewWidgetTaskSingle}
      storecastId={props.storecastId}
      interactive={false}
      clientForceSize={props.clientForceSize}
    />
  );
}
